import { Executor } from "../../services";
import { createModelStore } from "../../utils";

const executors = createModelStore<Executor.Model, "executors">("executors");

export default executors;
